import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import axiosInstance from '../../utils/axiosInstance';

// Async thunks
export const fetchAnalytics = createAsyncThunk(
    'analytics/fetchAnalytics',
    async (payload: { cardId: string }) => {

        const token = localStorage.getItem('viart_token');
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/${payload.cardId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });

        return response.data.data;
    }
);

export const trackVisit = createAsyncThunk(
    'analytics/trackVisit',
    async ({
        slug,
        country,
        city
    }: {
        slug: string;
        country?: string;
        city?: string;
    }) => {
        
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/${slug}/visit`, {
            ipAddress: '', // Backend will get this from request
            userAgent: navigator.userAgent,
            country: country || '',
            city: city || '',
        });
        return response.data;
    }
);

export const trackClick = createAsyncThunk(
    'analytics/trackClick',
    async (payload: { slug: string; buttonType: string; ipAddress?: string }) => {
        const response = await axiosInstance.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/analytics/${payload.slug}/click`,
            payload
        );
        return response.data;
    }
);